import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import { styled } from '@material-ui/core/styles';
import { container } from 'UI/constants/dimensions';
import { getHeaderBandBackground } from 'UI/theme/darkTones';

export const StyledCard = styled(Card)(({ theme, header }) => ({
  borderRadius: 12,
  boxShadow: container.boxShadow,
  height: '100%',
  overflow: 'unset',
  '& .MuiCardHeader-root, & .MuiCardMedia-root': {
    borderTopLeftRadius: theme.spacing(1.5),
    borderTopRightRadius: theme.spacing(1.5)
  },
  '& .cardContent .MuiToolbar-root': {
    borderTopLeftRadius: header ? 0 : theme.spacing(0.5),
    borderTopRightRadius: header ? 0 : theme.spacing(0.5)
  }
}));

export const StatsCardHeader = styled(CardHeader)(({ theme }) => ({
  backgroundColor: getHeaderBandBackground(theme),
  '& .MuiCardHeader-title': {
    color: theme.palette.grey[900]
  },
  '& .MuiCardHeader-action': {
    display: 'contents'
  },
  '& .MuiCardHeader-subheader': {
    fontSize: theme.typography.caption.fontSize
  }
}));

export const StatsCardContent = styled(CardContent)(({ theme, padding }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  justifyContent: 'left',
  padding: padding ?? theme.spacing(3, 2)
}));

export const ImgContainer = styled(CardMedia)({
  height: '160px',
  width: '100%',
  overflow: 'hidden',
  '& img': {
    height: '100%',
    width: '100%',
    objectFit: 'cover',
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
      cursor: 'pointer',
      transform: 'scale(1.1)'
    }
  }
});
